'use client'

import { convertMarkdown } from './parser'

function MarkdownTableContent({ content }) {
  return (
    <div id="markdown-table-content" className="flex flex-col gap-4">
      {convertMarkdown(content.content)}
    </div>
  )
}

export { MarkdownTableContent }
